import { AccountCircle } from "@material-ui/icons";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useState, useEffect } from "react";
import InputMask from "react-input-mask";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import BuscadorClienteFactura from "../../BusquedaCliente/BuscadorClienteFactura";
import { getData } from "../../../../../services/library";

function EdicionDatosCli({
  style,
  edicion,
  almacenar,
  variant,
  dataCliente,
  sitIvaSeleccionada,
  setSitIvaSeleccionada,
  color,
  ROnly,
  tipoCliente,
  tipoClienteSeleccionado,
  setTipoClienteSeleccionado,
  sitIva,
  // categorias,
  // categoriaSeleccionada,
  // setCategoriaSeleccionada,
  convenios,
  convenioSeleccionado,
  setConvenioSeleccionado,
  condiciones,
  condPagoSeleccionada,
  setCondPagoSeleccionada,
  sucursales,
  sucursalSeleccionada,
  setSucursalSeleccionada,
  provincias,
  provinciaSeleccionada,
  setProvinciaSeleccionada,
  setBuscando,
  buscando,
  localidades,
  localidadSeleccionada,
  setLocalidadSeleccionada,
  comerciales,
  comercialSeleccionado,
  setComercialSeleccionado,
  usos,
  usoSeleccionado,
  setUsoSeleccionado,
  codArg,
  disBtn,
  handleCancel,
  handleChangeChecked,
  handleCheckedPrecioEspecial,
  checked,
  setChecked,
  checkedPrecioEspecial,
  setCheckedPrecioEspecial,
  checkedEntregaConRemito,
  setCheckedEntregaConRemito,
  clienteFactura,
  handleClienteFacturaChange,
}) {
  // Verificacion de si el cliente esta en alguna hoja de ruta (para advertir al cambiar sucursal)
  const [hojas, setHojas] = useState(null);

  useEffect(() => {
    if (dataCliente?.id) {
      getData("/envasado_clientes_ruta/verificacion/" + dataCliente.id, setHojas);
    }
  }, [dataCliente?.id]);

  const cambioSucursalConHojas =
    sucursalSeleccionada?.id !== undefined &&
    sucursalSeleccionada.id !== dataCliente?.id_sucursal &&
    hojas &&
    hojas.length > 0;

  const formatearIIBB = (valor) => {
    if (!valor) return "";

    // Eliminar todo lo que no sea número
    let numeros = valor.replace(/\D/g, "");
    if (numeros.length > 10) numeros = numeros.slice(0, 10);

    // Aplicar formato progresivo
    if (numeros.length <= 3) return numeros;
    if (numeros.length <= 9)
      return `${numeros.slice(0, 3)}-${numeros.slice(3)}`;
    return `${numeros.slice(0, 3)}-${numeros.slice(3, 9)}-${numeros.slice(9, 10)}`;
  };

  return (
    <>
      <Grid container spacing={1.5}>
        <Grid item xs={3}>
          <TextField
            size="small"
            style={style}
            placeholder="Razon Social"
            type="text"
            required={edicion}
            focused
            name="razon_social"
            label="Razon Social"
            color="primary"
            onChange={almacenar}
            variant={variant}
            value={
              dataCliente.razon_social &&
              dataCliente.razon_social.replace(/\b\w/g, (l) => l.toUpperCase())
            }
            inputProps={{ maxLength: 200 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={sitIvaSeleccionada?.id === 1 ? 1.5 : 2}>
          <TextField
            size="small"
            onChange={almacenar}
            style={style}
            placeholder="No registrado"
            label="Sisven ID"
            name="sisven_id"
            color={color}
            focused
            variant={variant}
            value={dataCliente.sisven_id}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            inputProps={{ maxLength: 6 }} //solo 2 numeros
            InputProps={{
              readOnly: ROnly,
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircleIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={sitIvaSeleccionada?.id === 1 ? 1.5 : 3}>
          <Autocomplete
            disabled={!tipoCliente}
            required
            disableClearable
            id="id_tipocliente"
            style={style}
            size="small"
            noOptionsText={"Tipo de Cliente INEXISTENTE"}
            options={tipoCliente}
            autoHighlight
            getOptionLabel={(tc) => tc.descripcion}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={tipoClienteSeleccionado || null}
            defaultValue={tipoClienteSeleccionado || null}
            onChange={(event, value) => {
              setTipoClienteSeleccionado(value);
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.descripcion}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Tipo Cliente"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={sitIvaSeleccionada?.id === 1 ? 2.5 : 4}>
          <Autocomplete
            disabled={!sitIva}
            required
            disableClearable
            id="sitIva"
            style={style}
            size="small"
            noOptionsText={"Situación de IVA INEXISTENTE"}
            options={sitIva}
            autoHighlight
            getOptionLabel={(sit) => sit.descripcion}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={sitIvaSeleccionada || null}
            defaultValue={sitIvaSeleccionada || null}
            onChange={(event, value) => {
              setSitIvaSeleccionada(value);
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.descripcion}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Situación IVA"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>
        {sitIvaSeleccionada?.id === 1 ? (
          <>
            <Grid item xs={1.75}>
              <TextField
                size="small"
                style={{ backgroundColor: "#fff" }}
                fullWidth
                required
                placeholder=""
                disabled={sitIvaSeleccionada?.id === 1 ? false : true}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                focused
                inputProps={{ maxLength: 9 }} //solo 2 numeros
                name="porc_exc_perc_iva"
                label="% Exención Perc. IVA"
                color="primary"
                onChange={almacenar}
                value={dataCliente.porc_exc_perc_iva}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">%</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={1.75}>
              <TextField
                size="small"
                style={{ backgroundColor: "#fff" }}
                fullWidth
                required={dataCliente.porc_exc_perc_iva > 0 ? true : false}
                placeholder=""
                disabled={sitIvaSeleccionada?.id === 1 ? false : true}
                focused
                type="date"
                inputProps={{ maxLength: 9 }} //solo 2 numeros
                name="vto_exc_perc_iva"
                label="Vencimiento Exención"
                color="primary"
                onChange={almacenar}
                value={
                  dataCliente.vto_exc_perc_iva
                    ? moment(dataCliente.vto_exc_perc_iva).format("YYYY-MM-DD")
                    : ""
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start"></InputAdornment>
                  ),
                }}
              />
            </Grid>
          </>
        ) : null}
        {/* <Grid item xs={4}>
          <Autocomplete
            disabled={!categorias}
            required
            disableClearable
            id="categoria"
            style={style}
            size="small"
            noOptionsText={"Categoria Crediticia INEXISTENTE"}
            options={categorias}
            autoHighlight
            getOptionLabel={(cat) =>
              cat.categoria + " " + "(" + cat.descripcion + ")"
            }
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={categoriaSeleccionada || null}
            defaultValue={categoriaSeleccionada || null}
            onChange={(event, value) => {
              setCategoriaSeleccionada(value);
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.categoria} ({option.descripcion})
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Categoría Crediticia"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid> */}

        <Grid item xs={1}>
          <FormControl required style={style} focused size="small">
            <InputLabel>Cuit/Dni</InputLabel>
            <Select
              name="tipo_doc_afip"
              labelId="Cuit/Dni"
              disabled={sitIvaSeleccionada?.id !== 4}
              value={dataCliente.tipo_doc_afip}
              label="tipo_doc_afip"
              onChange={almacenar}
            >
              <MenuItem value={80}>Cuit</MenuItem>
              <MenuItem value={96}>Dni</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {dataCliente.tipo_doc_afip === 80 ? (
          <Grid item xs={2}>
            <InputMask
              mask="99999999999"
              value={dataCliente.cuit}
              disabled={false}
              maskChar=" "
              onChange={almacenar}
            >
              {() => (
                <TextField
                  size="small"
                  style={style}
                  fullWidth
                  defaultValue=""
                  type="text"
                  focused
                  name="cuit"
                  label="Numero Cuit"
                />
              )}
            </InputMask>
          </Grid>
        ) : (
          <Grid item xs={2}>
            <InputMask
              mask="99999999"
              value={dataCliente.cuit}
              disabled={false}
              maskChar=" "
              onChange={almacenar}
            >
              {() => (
                <TextField
                  size="small"
                  style={style}
                  fullWidth
                  defaultValue=""
                  type="text"
                  focused
                  name="cuit"
                  label="Numero Dni"
                />
              )}
            </InputMask>
          </Grid>
        )}
        <Grid item xs={3}>
          <Autocomplete
            disabled={!condiciones}
            required
            disableClearable
            id="id_condicionpago"
            style={style}
            size="small"
            noOptionsText={"Condición de Pago INEXISTENTE"}
            options={condiciones}
            autoHighlight
            getOptionLabel={(cond) => cond.condicion}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={condPagoSeleccionada || null}
            defaultValue={condPagoSeleccionada || null}
            onChange={(event, value) => {
              setCondPagoSeleccionada(value);
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.condicion}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Condición de Pago"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>
        {/* <Grid item xs={2}>
          <TextField
            size="small"
            type="number"
            style={style}
            placeholder="No registrado"
            label="Limite de crédito"
            name="limite_credito"
            onChange={almacenar}
            color={color}
            focused
            id="cuit"
            variant={variant}
            value={dataCliente.limite_credito}
            InputProps={{
              readOnly: ROnly,
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
        </Grid> */}

        <Grid item xs={3}>
          <TextField
            size="small"
            style={style}
            placeholder="No registrado"
            label="Direccion Fiscal"
            name="direccion_fiscal"
            color={color}
            onChange={almacenar}
            focused
            variant={variant}
            value={dataCliente.direccion_fiscal}
            InputProps={{
              readOnly: ROnly,
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <Autocomplete
            disabled={!sucursales}
            required
            disableClearable
            id="id_sucursal"
            style={style}
            size="small"
            noOptionsText={"Sucursal INEXISTENTE"}
            options={sucursales}
            autoHighlight
            getOptionLabel={(suc) => suc.nombre}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={sucursalSeleccionada || null}
            defaultValue={sucursalSeleccionada || null}
            onChange={(event, value) => {
              setSucursalSeleccionada(value);
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.nombre}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Sucursal"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={3}>
          <Autocomplete
            disabled={!provincias}
            required
            disableClearable
            id="id_provincia"
            style={style}
            size="small"
            noOptionsText={"Provincia INEXISTENTE"}
            options={provincias}
            autoHighlight
            getOptionLabel={(pr) => pr.provincia}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={provinciaSeleccionada || null}
            defaultValue={provinciaSeleccionada || null}
            onChange={(event, value) => {
              setProvinciaSeleccionada(value);
              setBuscando(true);
              dataCliente.id_localidad = "";
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.provincia}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Provincia"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={3}>
          {buscando === true ? (
            <TextField
              disabled
              focused
              fullWidth
              size="small"
              label="Buscando Localidades..."
            />
          ) : (
            <Autocomplete
              disabled={!localidades}
              required
              disableClearable
              id="id_localidad"
              style={style}
              size="small"
              noOptionsText={"Localidad INEXISTENTE"}
              options={localidades}
              autoHighlight
              getOptionLabel={(loc) => loc.localidad}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              value={localidadSeleccionada || null}
              defaultValue={localidadSeleccionada || null}
              onChange={(event, value) => {
                setLocalidadSeleccionada(value);
              }}
              renderOption={(props, option) => (
                <Box
                  component="li"
                  key={option.id}
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {option.localidad}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  placeholder="Tipee para buscar..."
                  {...params}
                  label="Localidad"
                  focused
                  inputProps={{
                    ...params.inputProps,
                  }}
                />
              )}
            />
          )}
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            disabled={!comerciales}
            required
            disableClearable
            id="id_comercial"
            style={style}
            size="small"
            noOptionsText={"Comercial INEXISTENTE"}
            options={comerciales}
            autoHighlight
            getOptionLabel={(c) => c.nombre_apellido}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={comercialSeleccionado || null}
            defaultValue={comercialSeleccionado || null}
            onChange={(event, value) => {
              setComercialSeleccionado(value);
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.nombre_apellido}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Comercial"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>
        {/* <Grid item xs={2}>
          <FormControl fullWidth>
            <TextField
              size="small"
              style={{ backgroundColor: "#fff" }}
              fullWidth
              type="number"
              color="primary"
              placeholder="..."
              name="envase_10_kg"
              label="Envase 10 KG"
              focused
              onChange={almacenar}
              value={dataCliente.envase_10_kg}
              inputProps={{
                maxLength: 10,
              }}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <FormControl fullWidth>
            <TextField
              size="small"
              style={{ backgroundColor: "#fff" }}
              fullWidth
              type="number"
              color="primary"
              placeholder="..."
              name="envase_15_kg"
              label="Envase 15 KG"
              focused
              onChange={almacenar}
              value={dataCliente.envase_15_kg}
              inputProps={{
                maxLength: 10,
              }}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <FormControl fullWidth>
            <TextField
              size="small"
              style={{ backgroundColor: "#fff" }}
              fullWidth
              type="number"
              color="primary"
              placeholder="..."
              name="envase_45_kg"
              label="Envase 45 KG"
              focused
              onChange={almacenar}
              value={dataCliente.envase_45_kg}
              inputProps={{
                maxLength: 10,
              }}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid> */}
        <Grid item xs={2}>
          <Autocomplete
            disabled={!usos}
            required
            disableClearable
            id="uso"
            style={style}
            size="small"
            noOptionsText={"Uso INEXISTENTE"}
            options={usos}
            autoHighlight
            getOptionLabel={(u) => u.uso}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={usoSeleccionado || null}
            defaultValue={usoSeleccionado || null}
            onChange={(event, value) => {
              setUsoSeleccionado(value);
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.uso}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Uso"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>
        {sitIvaSeleccionada?.inscripcion_iibb === 1 ? (
          <>
            <Grid item xs={3}>
              <Autocomplete
                disabled={!convenios}
                required
                disableClearable
                id="convenios"
                style={style}
                size={"small"}
                noOptionsText={"Convenio INEXISTENTE"}
                options={convenios}
                autoHighlight
                getOptionLabel={(c) => c.id_convenio + "-" + c.convenio}
                isOptionEqualToValue={(option, value) =>
                  option.id_convenio === value?.id_convenio
                }
                value={convenioSeleccionado || null}
                defaultValue={convenioSeleccionado || null}
                onChange={(event, value) => {
                  // Limpiar el campo IIBB cuando cambia el convenio
                  const mockEvent = {
                    target: {
                      name: "iibb_nro_inscripcion",
                      value: null,
                    },
                  };
                  almacenar(mockEvent);
                  setConvenioSeleccionado(value);
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    key={option.id_convenio}
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option.id_convenio} - {option.convenio}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    placeholder="Tipee para buscar..."
                    required
                    {...params}
                    label="Convenio"
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                size={"small"}
                style={style}
                placeholder="N° Inscripción IIBB"
                id="iibb_nro_inscripcion"
                name="iibb_nro_inscripcion"
                label="N° Inscripción IIBB"
                color="primary"
                value={dataCliente.iibb_nro_inscripcion || ""}
                onChange={(e) => {
                  let valor = e.target.value;

                  // Si el convenio ES 1, aplicar formato mientras escribe (con guiones)
                  if (convenioSeleccionado?.id_convenio === 1 && valor) {
                    valor = formatearIIBB(valor);
                  }

                  const mockEvent = {
                    target: {
                      name: e.target.name,
                      value: valor === "" ? null : valor,
                    },
                  };
                  almacenar(mockEvent);
                }}
                inputProps={{
                  maxLength: convenioSeleccionado?.id_convenio === 1 ? 13 : 200,
                }}
              />
            </Grid>
          </>
        ) : null}
        <Grid item xs={6}>
          <TextField
            size="small"
            style={style}
            placeholder="Observaciones"
            id="observaciones"
            name="observaciones"
            label="Observaciones"
            color="primary"
            focused
            value={dataCliente.observaciones}
            onChange={almacenar}
            inputProps={{ maxLength: 200 }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            size="small"
            style={style}
            placeholder="Observaciones cuenta corriente"
            id="observaciones_cuenta_corriente"
            name="observaciones_cuenta_corriente"
            label="Observaciones cuenta corriente"
            color="primary"
            focused
            value={dataCliente.observaciones_cuenta_corriente}
            onChange={almacenar}
            inputProps={{ maxLength: 200 }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            size="small"
            style={style}
            placeholder="Mail no registrado"
            label="Mails"
            onChange={almacenar}
            name="mails"
            color={color}
            focused
            variant={variant}
            value={dataCliente.mails}
            InputProps={{
              readOnly: ROnly,
              startAdornment: (
                <InputAdornment position="start">
                  <ContactMailIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={2}>
          <TextField
            size="small"
            type="text"
            onChange={almacenar}
            style={style}
            placeholder="No registrado"
            label="Telefono"
            name="telefono_1"
            color={color}
            focused
            variant={variant}
            value={dataCliente.telefono_1}
            inputProps={{
              readOnly: ROnly,
              maxLength: 10,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{codArg}</InputAdornment>
              ),
            }}
            // helperText={
            //   edicion
            //     ? "Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
            //     : ""
            // }
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            size="small"
            type="text"
            style={style}
            placeholder="No registrado"
            label="Telefono 2"
            name="telefono_2"
            color={color}
            focused
            variant={variant}
            value={dataCliente.telefono_2}
            onChange={almacenar}
            inputProps={{
              readOnly: ROnly,
              maxLength: 10,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{codArg}</InputAdornment>
              ),
            }}
            // helperText={
            //   edicion
            //     ? "Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
            //     : ""
            // }
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            size="small"
            type="text"
            onChange={almacenar}
            style={style}
            placeholder="No registrado"
            label="Telefono"
            name="telefono_3"
            color={color}
            focused
            variant={variant}
            value={dataCliente.telefono_3}
            inputProps={{
              readOnly: ROnly,
              maxLength: 10,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{codArg}</InputAdornment>
              ),
            }}
            // helperText={
            //   edicion
            //     ? "Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
            //     : ""
            // }
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </Grid>

        {/* <Grid item xs={2.4} alignContent={"unset"}>
          <FormGroup>
            <FormControlLabel
              disabled={!edicion}
              label="Precio Especial"
              control={
                <Checkbox
                  checked={checkedPrecioEspecial}
                  onChange={handleCheckedPrecioEspecial}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
          </FormGroup>
        </Grid> */}
        <Grid item xs={2.5}>
          <Paper
            elevation={0}
            sx={{
              // p: 0.5,
              border: "2px solid",
              borderColor: checkedPrecioEspecial ? "primary.main" : "grey.300",
              borderRadius: 3,
              height: 38,
              transition: "all 0.3s ease",
              cursor: "pointer",
              bgcolor: checkedPrecioEspecial ? "primary.50" : "transparent",
              display: "flex",
              alignItems: "center",
              "&:hover": {
                borderColor: "primary.main",
                bgcolor: checkedPrecioEspecial ? "primary.100" : "grey.50",
                transform: "translateY(-2px)",
                boxShadow: 2,
              },
            }}
            onClick={() => setCheckedPrecioEspecial((prev) => !prev)}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
              width="100%"
              // onClick={(e) => e.stopPropagation()}
            >
              <Checkbox
                checked={checkedPrecioEspecial}
                // onChange={handleChangeChecked}
                tabIndex={-1}
                disableRipple
                sx={{
                  "& .MuiSvgIcon-root": { fontSize: 28 },
                }}
              />
              <Typography
                variant="body1"
                fontWeight={600}
                sx={{ userSelect: "none" }}
              >
                Precio Especial
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {/* <Grid item xs={2.4} alignContent={"unset"}>
          <FormGroup>
            <FormControlLabel
              disabled={!edicion}
              label="Factura Consumidor Final"
              control={
                <Checkbox
                  checked={checked}
                  onChange={handleChangeChecked}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
          </FormGroup>
        </Grid> */}
        <Grid item xs={3}>
          <Paper
            elevation={0}
            sx={{
              // p: 0.5,
              border: "2px solid",
              borderColor: checked ? "primary.main" : "grey.300",
              borderRadius: 3,
              height: 38,
              transition: "all 0.3s ease",
              cursor: "pointer",
              bgcolor: checked ? "primary.50" : "transparent",
              display: "flex",
              alignItems: "center",
              "&:hover": {
                borderColor: "primary.main",
                bgcolor: checked ? "primary.100" : "grey.50",
                transform: "translateY(-2px)",
                boxShadow: 2,
              },
            }}
            onClick={() => setChecked((prev) => !prev)}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
              width="100%"
              // onClick={(e) => e.stopPropagation()}
            >
              <Checkbox
                checked={checked}
                // onChange={handleChangeChecked}
                tabIndex={-1}
                disableRipple
                sx={{
                  "& .MuiSvgIcon-root": { fontSize: 28 },
                }}
              />
              <Typography
                variant="body1"
                fontWeight={600}
                sx={{ userSelect: "none" }}
              >
                Factura Consumidor Final
              </Typography>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={2.5}>
          <Paper
            elevation={0}
            sx={{
              // p: 0.5,
              border: "2px solid",
              borderColor: checkedEntregaConRemito
                ? "primary.main"
                : "grey.300",
              borderRadius: 3,
              height: 38,
              transition: "all 0.3s ease",
              cursor: "pointer",
              bgcolor: checkedEntregaConRemito ? "primary.50" : "transparent",
              display: "flex",
              alignItems: "center",
              "&:hover": {
                borderColor: "primary.main",
                bgcolor: checkedEntregaConRemito ? "primary.100" : "grey.50",
                transform: "translateY(-2px)",
                boxShadow: 2,
              },
            }}
            // onClick={handleCheckedEntregaConRemito}
            onClick={() => setCheckedEntregaConRemito((prev) => !prev)}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
              width="100%"
              // onClick={(e) => e.stopPropagation()}
            >
              <Checkbox
                checked={checkedEntregaConRemito}
                // onChange={handleCheckedEntregaConRemito}
                tabIndex={-1}
                disableRipple
                sx={{
                  "& .MuiSvgIcon-root": { fontSize: 28 },
                }}
              />
              <Typography
                variant="body1"
                fontWeight={600}
                sx={{ userSelect: "none" }}
              >
                Entrega con Remito
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {(checkedEntregaConRemito || clienteFactura) && (
          <Grid item xs={12} md={4}>
            <BuscadorClienteFactura
              value={clienteFactura}
              onChange={handleClienteFacturaChange}
              style={style}
              size={"small"}
              label="Facturar a"
              placeholder="Buscar cliente por razón social, CUIT..."
            />
          </Grid>
        )}
      </Grid>
      {cambioSucursalConHojas && (
        <Alert severity="warning" sx={{ mt: 1, mr: 1 }}>
          El cliente está asignado a las siguientes hojas de ruta. Si cambia la
          sucursal, revise las hojas:
          <ul style={{ margin: 0 }}>
            {hojas.map((h) => (
              <li key={h.id}>{h.nombre_hoja}</li>
            ))}
          </ul>
        </Alert>
      )}
      <Grid
        // ml={2}
        mt={1}
        mr={1}
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Button
          variant="contained"
          disabled={disBtn}
          onClick={handleCancel}
          color="error"
        >
          Volver
        </Button>
        <Button
          variant="contained"
          disabled={disBtn}
          color="success"
          type="submit"
        >
          Guardar Cliente
        </Button>
      </Grid>
    </>
  );
}

export default EdicionDatosCli;
